import axiosInstance from './axiosConfig';

// Regional level unit consumption record getting here
export const referalCodeApi = async () => {
  const response = await axiosInstance.get(`/users/referral_code`);
  return response.data;
};
